import React from 'react'
import MobileLayout from '../../MobileLayout'
import Text from '../../atoms/Text'

const QuestionairreInfoSheet = () => {
  const questions = [
    {
      text: `🧍 Age & BMI - Helps us assess your nutritional needs and metabolic health.`,
    },
    {
      text: "🏃 Daily Activity Level – Whether you're sedentary or very active, your food needs change based on energy expenditure.",
    },
    {
      text: '🩺 Existing Health Conditions – Conditions like diabetes, hypertension, cardiovascular disease, or CKD affect how your body processes nutrients.',
    },
    {
      text: "🧬 Family & Past Medical History – Knowing if you've had a heart attack, stroke, or kidney disease helps us provide the right dietary guidance.",
    },
    {
      text: '🚫 Other Risk Factors – We consider additional health conditions like anemia, asthma, and proteinuria to ensure food recommendations fit your unique health needs.',
    },
  ]
  return (
    <MobileLayout>
      <div className="pt-14 p-4 lg:px-12 lg:pt-10 lg:pb-8 lg:mt-0 lg:max-w-3xl lg:mx-auto">
        <Text variant="display" size="large">
          Why these questions matter?
        </Text>
        <Text
          variant="body"
          size="large"
          tag={'p'}
          className={'mt-4 text-text-primary'}
        >
          To give you the most accurate PNDS (Personalized Nutri-Diet Score), we
          ask about your body, lifestyle, and health history. Here's why:
        </Text>
        <div className="flex flex-col gap-5 mt-5">
          {questions.map((data) => (
            <Text
              variant="body"
              size="large"
              className={'relative '}
              tag={'div'}
            >
              <p className="">{data.text}</p>
            </Text>
          ))}

          <Text variant="body" size="large" className={'text-text-primary'}>
            By understanding your body and lifestyle, we can tailor your food
            score to help you eat smarter and healthier! 🚀
          </Text>
        </div>
      </div>
    </MobileLayout>
  )
}

export default QuestionairreInfoSheet
